import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute, Params } from '@angular/router';
import { SupportUrl } from 'src/app/commons/url';
import { LinkService } from 'src/app/services/general/link.service';
import { SupportType } from 'src/app/types/general';
import { SupportTicketType } from 'src/app/types/support';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.page.html',
  styleUrls: ['./contact.page.scss'],
})
export class ContactPage implements OnInit, OnDestroy {

  ready: boolean;
  backHelpPage: boolean;
  backRatingPage: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
      
  }

  ionViewWillEnter() {
    this.ready = true;
  }

  ionViewWillLeave() {
    this.ready = false;
  }

  /**
   * Watch Route
   */
  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;
      if (param.backHelpPage) {
        this.backHelpPage = true;
      } else if (state?.backHelpPage) {
        this.backHelpPage = true;
      } else {
        this.backHelpPage = false;
      }

      if (param.backRatingPage) {
        this.backRatingPage = true;
      } else if (state?.backRatingPage) {
        this.backRatingPage = true;
      } else {
        this.backRatingPage = false;
      }
    });
  }

  goBack() {
    if (this.backRatingPage) {
      this.goRatingPage();
    } else if (this.backHelpPage) {
      this.goHelpPage();
    } else {
      this.goMainPage();
    }
  }

  goRatingPage() {
    const navigationExtras: NavigationExtras = {
      state: { showPage: true, backHelpPage: this.backHelpPage }
    };
    this.router.navigate(['/about/app-rating/true'], navigationExtras);
  }

  goHelpPage() {
    this.router.navigate(['/about/help']);
  }

  /**
   * Go main page
   */
  goMainPage() {
    this.linkService.goMainPage();
  }

  goSupportPage(ticketType: SupportTicketType) {
    const navigationExtras: NavigationExtras = {
      state: {
        ticketType,
        backRatingPage: this.backRatingPage,
        backHelpPage: this.backHelpPage,
      }
    };
    this.router.navigate(['/about/support'], navigationExtras);
  }

  /**
   * Open support type
   * @param type Support type
   */
  async open(type: SupportType) {
    if (type && SupportUrl) {
      const url = SupportUrl?.[type];
      if (url) {
        if (type === 'facebook') {
          this.linkService.openUrl(url);
        } else {
          window.open(url, '_system');
        }
      }
    }
  }
}
